import { AxiosResponse } from "axios";
import { useEffect, useState } from "react";
import Select from "react-select";
import InsuranceService from "../../../../Services/InsuranceService/InsuranceService";
import { CrossIcon } from "../../../../Shared/Icons";
import { styles } from "../../../../Utils/Common";
import useLang from "Shared/hooks/useLanguage";
import usePageFieldConfig from "Shared/hooks/usePageFieldConfig";
import { getValueFromSessionStorage } from "Utils/Common/CommonMethods";

const calcTotalPrice = (itemPrice: any, quantity: any) => {
  const price = Number(itemPrice);
  const qty = Number(quantity);
  if (Number.isNaN(price) || Number.isNaN(qty)) return 0;
  return Number((price * qty).toFixed(2));
};

function InputsRow(props: {
  itemTypes: any;
  supplyOrders: any;
  i: any;
  setSupplyOrders: any;
  register: any;
  errors: any;
  remove: any;
  field: any;
  clearErrors: any;
  setValue: any;
  handleKeyPress: any;
  hasAnyStripeItem?: boolean;
}) {
  const { t } = useLang();

  const {
    itemTypes,
    supplyOrders,
    i,
    setSupplyOrders,
    register,
    errors,
    remove,
    field,
    clearErrors,
    setValue,
    handleKeyPress,
    hasAnyStripeItem = false,
  } = props;

  const ItemPriceConfig = usePageFieldConfig(
    Number(getValueFromSessionStorage("pageId")),
    "TotalItemPrice"
  );
  const showTotalItemPrice = ItemPriceConfig?.isShow === true;

  const ShippingCommentsConfig = usePageFieldConfig(
    Number(getValueFromSessionStorage("pageId")),
    "ShippingComments"
  );
  const showShippingComments = ShippingCommentsConfig?.isShow === true;

  const [dropdown2, setDropdown2] = useState([]);
  const [itemTypeChanged, setItemTypeChanged] = useState(null);

  const loadItemLookUp = (type: any) => {
    InsuranceService.GetItemLookup(type)
      .then((res: AxiosResponse) => {
        setDropdown2(res?.data);
      })
      .catch((err: any) => {
        console.trace(err, "err");
      });
  };

  const GetSupplyItemDescriptionById = (
    e: any,
    index: number,
    name: string
  ) => {
    InsuranceService.GetSupplyItemDescriptionById(e.value)
      .then((res: AxiosResponse) => {
        const data = res?.data?.data;
        const itemDescription =
          typeof data === "string" ? data : (data?.itemDescription ?? "");
        const itemPrice =
          typeof data === "object" && data !== null
            ? (data?.itemPrice ?? null)
            : null;
        let additionConfig = "";
        if (typeof data === "object" && data !== null) {
          const config = data?.additionConfig;
          if (typeof config === "string") {
            additionConfig = config;
          } else if (config && typeof config === "object") {
            additionConfig = JSON.stringify(config);
          }
        }

        setSupplyOrders((prev: any[]) => {
          const newSupplyOrders = [...prev];
          const quantity = newSupplyOrders[index]?.orderQuantityRequested;
          newSupplyOrders[index] = {
            ...newSupplyOrders[index],
            itemDescription,
            itemPrice,
            totalPrice: calcTotalPrice(itemPrice, quantity),
            additionConfig,
            [name]: e.label,
            supplyItemId: e.value,
          };
          return newSupplyOrders;
        });
      })
      .catch((err: any) => {
        console.trace(err, "err");
      });
  };

  const handleChangeSupplyOrder = (e: any, name: string, index: any) => {
    const newSupplyOrders = [...supplyOrders];
    if (name === "itemName") {
      newSupplyOrders[index] = {
        ...newSupplyOrders[index],
        [name]: e.label,
        supplyItemId: e.value,
        additionConfig: "",
      };
      GetSupplyItemDescriptionById(e, index, name);
    } else if (name === "itemType") {
      newSupplyOrders[index] = {
        ...newSupplyOrders[index],
        [name]: e.label,
        itemName: "",
        supplyItemId: 0,
        itemDescription: "",
        itemPrice: 0,
        totalPrice: 0,
        additionConfig: "",
      };
      setItemTypeChanged(e.value);
    } else {
      newSupplyOrders[index] = {
        ...newSupplyOrders[index],
        [name]: e.label,
      };
    }
    setSupplyOrders(newSupplyOrders);

    setValue(`supplyOrder.${index}.${name}`, `supplyOrder.${index}.${e.value}`);
    clearErrors(`supplyOrder.${index}.${name}`);
  };

  const onInputChange = (e: any, index: number) => {
    const { name, value } = e.target;
    const newSupplyOrders = [...supplyOrders];
    const updatedRow = {
      ...newSupplyOrders[index],
      [name]: value,
    };

    if (name === "orderQuantityRequested") {
      updatedRow.totalPrice = calcTotalPrice(updatedRow.itemPrice, value);
    }

    newSupplyOrders[index] = updatedRow;
    setSupplyOrders(newSupplyOrders);
    setValue(`supplyOrder.${index}.${name}`, value);
    if (name === "orderQuantityRequested") {
      setValue(`supplyOrder.${index}.totalPrice`, updatedRow.totalPrice);
    }
    clearErrors(`supplyOrder.${index}.${name}`);
  };

  useEffect(() => {
    if (itemTypeChanged !== null) {
      loadItemLookUp(itemTypeChanged);
      setItemTypeChanged(null);
    }
  }, [supplyOrders, itemTypeChanged]);

  return (
    <>
      <div
        style={{ position: "absolute", top: 0, right: 2, zIndex: 10 }}
        className="p-2"
      >
        <button
          id={`ManageOrderNewOrderRemoveRow`}
          className="btn btn-icon btn-sm fw-bold btn-table-cancel btn-danger h-27px w-30px fas-icon-20px"
          onClick={() => {
            const remainingSupplyOrders = supplyOrders.filter(
              (_: any, index: any) => index !== i
            );
            setSupplyOrders(remainingSupplyOrders);
            remove(i);
          }}
        >
          <CrossIcon />
        </button>
      </div>

      <div className="row" key={field.id}>
        <div className="col-xl-2 col-md-3 col-sm-6 col-12">
          <div className="fv-row mb-4">
            <label className="mb-2 fw-500 required">{t("Item Type")}</label>
            <Select
              inputId={`ManageOrderNewOrderItemType`}
              menuPortalTarget={document.body}
              {...register(`supplyOrder.${i}.itemType`, { required: true })}
              options={itemTypes}
              theme={(theme: any) => styles(theme)}
              placeholder={t("Item Type")}
              name="itemType"
              value={itemTypes?.filter(
                (item: any) => item.label === supplyOrders[i]?.itemType
              )}
              onChange={(event: any) => {
                handleChangeSupplyOrder(event, "itemType", i);
              }}
            />
            {errors.supplyOrder?.[i]?.itemType && (
              <p className="text-danger px-2">
                {t("Please select the Item Type.")}
              </p>
            )}
          </div>
        </div>
        <div className="col-xl-2 col-md-3 col-sm-6 col-12">
          <div className="fv-row mb-4">
            <label className="required mb-2 fw-500">{t("Item")}</label>
            <Select
              inputId={`ManageOrderNewOrderItem`}
              menuPortalTarget={document.body}
              {...register(`supplyOrder.${i}.itemName`, { required: true })}
              options={dropdown2}
              theme={(theme: any) => styles(theme)}
              placeholder={t("Item")}
              name="itemName"
              value={dropdown2?.filter(
                (item: any) => item.label === supplyOrders[i]?.itemName
              )}
              onChange={(event: any) => {
                handleChangeSupplyOrder(event, "itemName", i);
              }}
            />
            {errors.supplyOrder?.[i]?.itemName && (
              <p className="text-danger px-2">
                {t("Please select the Item Name.")}
              </p>
            )}
          </div>
        </div>
        <div className="col-xl-2 col-md-3 col-sm-6 col-12">
          <div className="fv-row mb-4">
            <label className="required mb-2 fw-500">
              {t("Item Description")}
            </label>
            <input
              id={`ManageOrderNewOrderItemDescription`}
              {...register(`supplyOrder.${i}.itemDescription`)}
              type="text"
              name="itemDescription"
              className="form-control"
              placeholder={t("Item Description")}
              value={supplyOrders[i]?.itemDescription}
              disabled={true}
            />
          </div>
        </div>
        <div className="col-xl-2 col-md-3 col-sm-6 col-12">
          <div className="fv-row mb-4">
            <label className="required mb-2 fw-500">
              {t("Order Quantity")}
            </label>
            <input
              id={`ManageOrderNewOrderOrderQuantity`}
              {...register(`supplyOrder.${i}.orderQuantityRequested`, {
                required: t("Order Quantity must be greater than 0."),
                validate: (value: number) =>
                  Number(value) > 0 ||
                  t("Order Quantity must be greater than 0."),
              })}
              type="text"
              name="orderQuantityRequested"
              onChange={(e) => onInputChange(e, i)}
              onKeyDown={(e) => handleKeyPress(e)}
              className="form-control bg-transparent"
              placeholder={t("Order Quantity")}
              inputMode="numeric"
              value={supplyOrders[i]?.orderQuantityRequested}
            />
            {errors.supplyOrder?.[i]?.orderQuantityRequested && (
              <p className="text-danger px-2">
                {t("Order Quantity must be greater than 0.")}
              </p>
            )}
          </div>
        </div>
        {showTotalItemPrice && hasAnyStripeItem ? (
          <>
            <div className="col-xl-2 col-md-3 col-sm-6 col-12">
              <div className="fv-row mb-4">
                <label className="mb-2 fw-500">{t("Price")}</label>
                <input
                  id={`ManageOrderNewOrderItemPrice_${i}`}
                  type="text"
                  name="itemPrice"
                  className="form-control"
                  placeholder={t("Price")}
                  value={
                    supplyOrders[i]?.itemPrice !== null &&
                    supplyOrders[i]?.itemPrice !== ""
                      ? supplyOrders[i]?.itemPrice
                      : ""
                  }
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-xl-2 col-md-3 col-sm-6 col-12">
              <div className="fv-row mb-4">
                <label className="mb-2 fw-500">{t("Total Price")}</label>
                <input
                  id={`ManageOrderNewOrderTotalPrice_${i}`}
                  type="text"
                  name="totalPrice"
                  className="form-control"
                  placeholder={t("Total Price")}
                  value={
                    supplyOrders[i]?.totalPrice !== null &&
                    supplyOrders[i]?.totalPrice !== ""
                      ? supplyOrders[i]?.totalPrice
                      : ""
                  }
                  disabled={true}
                />
              </div>
            </div>
          </>
        ) : null}
        {showShippingComments ? (
          <div className="col-xl-2 col-md-3 col-sm-6 col-12">
            <div className="fv-row mb-4">
              <label className="mb-2 fw-500" style={{ whiteSpace: "nowrap" }}>
                {t("Shipping Comments")}
              </label>
              <input
                id={`ManageOrderNewOrderShippingComments_${i}`}
                {...register(`supplyOrder.${i}.shippingComments`)}
                type="text"
                name="shippingComments"
                onChange={(e) => onInputChange(e, i)}
                className="form-control bg-transparent"
                placeholder={t("Shipping Comments")}
                value={supplyOrders[i]?.shippingComments ?? ""}
              />
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}

export default InputsRow;
